/**
 * Loads involve popup script based on the given pathname.
 *
 * @param {HTMLScriptElement} popupScript - The popup script to be loaded
 * @param {string} pathname - The pathname to check against the current window location
 * @return {void} No return value
 */

function loadInvolvePopup(
  popupScript: HTMLScriptElement,
  showInvolvePopup: boolean,
): void {
  if (showInvolvePopup) {
    const involveScript = document.createElement('script');
    involveScript.src = 'https://letrus-estudante.involve.me/embed?type=popup';
    document.body.appendChild(involveScript);

    involveScript.onload = () => {
      // adds the script to the document and runs it after involve script is loaded
      const involvePopupScript = document.body.appendChild(popupScript);
      // eslint-disable-next-line no-eval
      (0, eval)(involvePopupScript.innerText);
    };
  } else {
    // removes all the involve scripts from the document
    const nodesToRemove: ChildNode[] = [];
    document.body.childNodes.forEach((node) => {
      const isInvolveScript =
        node instanceof HTMLScriptElement && node.src.includes('involve.me');

      const isInvolvePopupScript =
        node instanceof HTMLScriptElement &&
        node.innerText.includes('involvemeEmbedPopup');

      const isInvolveButton = node.nodeName === 'BUTTON';
      if (isInvolveScript || isInvolveButton || isInvolvePopupScript) {
        nodesToRemove.push(node);
      }
    });

    nodesToRemove.forEach((node) => node.remove());
  }
}

export default loadInvolvePopup;
